import React, { useEffect } from 'react'
import {
    DimensionProps,
    withDimensions,
} from '../../../__helpers/with-dimensions'
import { StyledNavigation } from './TNNavHeaderWithStickyBanner.styled'
import { NavEvent, QuickLinks } from '@news-mono/web-common'
import { TNQuickLinks } from '@news-mono/component-library'
import {
    HeaderDisplayState,
    HeaderScrollType,
} from '../../../content/TheNightlyStickySiteHeader/helper/site-header-state-helper'
import { StickyAccountBannerWrapper } from '../../warden/sticky-account-banner/StickyAccountBanner'

export interface TNNavHeaderWithStickyBannerProps {
    onEvent: (event: NavEvent) => void

    adHeight: number
    isChanging: boolean
    scrollType: HeaderScrollType
    displayState: HeaderDisplayState
    navigation: JSX.Element
    quickLinks: QuickLinks
}

type InternalProps = TNNavHeaderWithStickyBannerProps & DimensionProps

export const InternalTNNavHeaderWithStickyBanner: React.FC<InternalProps> = ({
    height,
    adHeight,
    isChanging,
    scrollType,
    displayState,
    innerRef,
    navigation,
    quickLinks,
    onEvent,
}) => {
    const totalHeight = height + adHeight
    const stickyBannerHeight =
        displayState === 'full'
            ? totalHeight
            : displayState === 'header'
            ? height
            : 0

    useEffect(() => {
        document.documentElement.style.setProperty(
            '--stickyHeaderHeight',
            `${stickyBannerHeight}px`,
        )
    }, [stickyBannerHeight])

    return (
        <>
            <StyledNavigation
                className="header-navigation"
                displayState={displayState}
                isChanging={isChanging}
                scrollType={scrollType}
                height={height}
                ref={innerRef}
                adHeight={adHeight}
            >
                {navigation}
                <TNQuickLinks links={quickLinks} onEvent={onEvent} />
            </StyledNavigation>
            <StickyAccountBannerWrapper
                isHidden={false}
                message="Join The Nightly for full access."
            />
        </>
    )
}

export const TNNavHeaderWithStickyBanner =
    withDimensions<TNNavHeaderWithStickyBannerProps>(
        InternalTNNavHeaderWithStickyBanner,
    )

TNNavHeaderWithStickyBanner.displayName = 'TNNavHeaderWithStickyBanner'
